/**
 * This component must stay in AJS until router is migrated, because of "ui-view" in the template
 */
TasksListNgController.$inject = ['$scope', '$state', 'taskListConfiguration', 'TopToolbarFactory'];
export function TasksListNgController($scope, $state, taskListConfiguration, TopToolbarFactory) {
  $scope.taskListConfiguration = taskListConfiguration;
  $scope.hideInbox = false;

  init();

  function init() {
    $scope.$watch(
      () => $state.includes('**.process'),
      () => {
        updateTitle();
        $scope.hideInbox = $state.includes('**.process');
      }
    );

    $scope.title = taskListConfiguration.title;
  }

  function updateTitle() {
    if ($state.includes('**.process')) {
      TopToolbarFactory.clearTitle($scope);
    } else if ($scope.title) {
      TopToolbarFactory.setTitle($scope.title, $scope);
    }
  }
}
